import { render, staticRenderFns } from "./CallAndVerifyView.vue?vue&type=template&id=60664cd8&scoped=true&"
import script from "./CallAndVerifyView.vue?vue&type=script&lang=js&"
export * from "./CallAndVerifyView.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=60664cd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60664cd8",
  null
  
)

export default component.exports